<template>
  <v-card class="mb-6 pb-4">
    <div class="px-4 pt-4 d-flex align-center">
      <!-- Flexible Größe für das numberplate-form -->
      <div class="flex-grow-1">
        <numberplate-form :value="numberplate" :disabled="true"></numberplate-form>
      </div>

      <!-- Menü bleibt rechts -->
      <v-menu offset-y v-if="vehicle && !vehicle?.decommissioningDate">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="openDecommissioningDialog">
            <v-list-item-title>{{ $t("components.thg.ThgMyVehicle.vehicleUnregister") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <thg-my-vehicle-decommission-dialog
      ref="decommisionDialog"
      :thgs="thgs"
      :vehicle="vehicle"
    ></thg-my-vehicle-decommission-dialog>
    <thg-my-vehicle-registration-detail :vehicle="vehicle" :thgs="thgs" />
    <thg-my-vehicle-renewal-options-sheet :vehicle="vehicle" :thgs="thgs" />
    <thg-my-vehicle-thg-quote-detail v-for="thg of thgs" :thg="thg" :key="thg.id" />
  </v-card>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { IThgMyVehicle } from "@/models/thg-my-vehicle.entity";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import ImageDialog from "../utility/ImageDialog.vue";
import NumberplateForm from "../utility/NumberplateForm.vue";
import ThgMyVehicleDecommissionDialog from "./ThgMyVehicleDecommissionDialog.vue";
import ThgMyVehicleRegistrationDetail from "./ThgMyVehicleRegistrationDetail.vue";
import ThgMyVehicleRenewalOptionsSheet from "./ThgMyVehicleRenewalOptionsSheet.vue";
import ThgMyVehicleThgQuoteDetail from "./ThgMyVehicleThgQuoteDetail.vue";

@Component({
  components: {
    NumberplateForm,
    ImageDialog,
    ThgMyVehicleRenewalOptionsSheet,
    ThgMyVehicleRegistrationDetail,
    ThgMyVehicleThgQuoteDetail,
    ThgMyVehicleDecommissionDialog
  }
})
export default class ThgMyVehicle extends DarkModeHighlightMixin {
  @Prop()
  vehicle!: IThgMyVehicle;

  @Prop()
  thgs!: ThgThgMeViewModelGen[];

  decomissionDialog = false;

  get numberplate() {
    if (this.thgs.length) {
      return this.thgs[0]?.numberplate || "";
    }

    return "";
  }

  openDecommissioningDialog() {
    (this.$refs.decommisionDialog as ThgMyVehicleDecommissionDialog)?.open();
  }
}
</script>
